module.exports = __webpack_public_path__ + "img/login-v2.3c174d04.svg";